import 'ol/ol.css';
import { Vector as VectorLayer, Heatmap } from 'ol/layer'
import { Vector as VectorSource } from 'ol/source'
import { Style, Stroke, Fill, Text, RegularShape } from 'ol/style.js';
import GeoJSON from "ol/format/GeoJSON";
import Point from "ol/geom/Point";
import { interpolateColors, runAnimationFeature, setMapSingleEventHandler, setSourceForGeoJSON } from 'map/OlExtension'
import { getVectorContext } from 'ol/render';
import { unByKey } from 'ol/Observable';
import { getRandomIntInclusive, hexToRgba, settingsConfig } from 'utils/commonFunc';
import defColors from 'utils/defColors';
import ApiService from 'services/ApiService';

export default class LayerLinkHeat extends VectorLayer {
    constructor(map) {
        super({
            name: 'linkHeatLayer',
            opacity: settingsConfig().mapOpacityLink2 ?? 0.3,
            userLayer: true,
            layerIndex: 0,
        });
        this.map = map;        
        this.map?.addLayer(this);
        this.setStyle(this.styleFunction)
        this.setData();
    }

    styleCache = {};
    styleFunction = (feature, _) => {
        const lvl = feature.get('lvl')
        let style = this.styleCache[lvl];
        if (!style) {
            let color = 'rgb( 100, 100, 100)'//'rgba( 100, 100, 100, 1)'
            //let color = defColors.trafficColors[2]//hexToRgba(, 1.0);
            switch (lvl) {
                case 0:
                    color = 'rgb( 100, 100, 100)';
                    break;
                case 1:
                    color = defColors.trafficColors[2]//hexToRgba(, 1.0);
                    break;
                case 2:
                    color = defColors.trafficColors[1]//hexToRgba(defColors.trafficColors[1], 1.0);
                    break;
                case 3:
                    color = defColors.trafficColors[0]//hexToRgba(defColors.trafficColors[0], 1.0);
                    break;
                default:
                    break;
            }
            style = this.styleCache[lvl] = new Style({
                fill: new Fill({
                    color: color
                })
            });
        }

        return style
    }

    updateSpd = (items) => {
        this.getSource()?.forEachFeature(feature => {
            const id = feature.get("LINK2_ID")
            const lvl = items[id];

            if (feature.get("lvl") !== lvl) {
                feature.set("lvl", lvl)
            }
        });
    }

    setData = function () {
        const layer = this;
        // ApiService.get("newdashboard/gis/Link2GeoJson").then(response => {
        //     if (response.status === 200) {
        //         const data = response.data;
        //         setSourceForGeoJSON(layer, data);
        //     }
        // })
        ApiService.get("dashboard/Map/GeoJson").then(response => {
            if (response.status === 200) {
                const data = response.data;
                setSourceForGeoJSON(layer, data.link2);
            }
        })
    }

    setHeatData = function (dateStr) {
        const layer = this;
        const sdtm = dateStr + "00";
        const edtm = dateStr + "23";
        const url = "newdashboard/gis/Link2HitMapData?sdtm="+sdtm+"&edtm="+edtm;
        ApiService.get(url).then(response => {
            if (response.status === 200) {
                const data = response.data;                        
                layer.link2SpdRows = data.link2SpdRows;

                if(layer.link2SpdRows[sdtm]) {
                    layer.updateSpd(layer.link2SpdRows[sdtm]);
                } else {
                    layer.getSource()?.forEachFeature(feature => {
                        feature.set("lvl", 0)
                    });
                }
            }
        })
    }

    changeTime = function (dateTimeStr) {
        const layer = this;
        if(layer.link2SpdRows) {
            if(layer.link2SpdRows[dateTimeStr]) {
                layer.updateSpd(layer.link2SpdRows[dateTimeStr]);
            }
        }
    }
}